module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAaCAYAAACzdqxAAAAAAXNSR0IArs4c6QAAARJJREFUSEvtljFOw0AQRf8HIRHkC/gOCCkHAE4AOca4dgEVilNC4XrXl4CGAxD6ICHu4BsYJIg/2iAjC1JgBxrkKXf1386MRvOXAOCcOwEwI3kAYDuc9YilpEeSF2Z2ywAleQNgqwdsnaSu63oSwAuSYwBXIWszq/o84L3fAzAFcCbpgd77t1B+WZajLMte+kAbTZZlu3EcPwNYBrDChZlxE2ijbXgDGEMrPgdqaMXQiu/b5R9PhXNuTvKwXbSk+yRJjtat2R+3wnt/B+ArZG5mxxuBuy7/dsZ/Zk0LAGNJl1VVzdI0DZ7VOfI8H0VRNJV0vjLToihOJV3/pv2TnKwMtPVh2Qew0zndD8GrpKfmw/IOw9PjNAkbA3IAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-tel.png
// module id = q3Rl
// module chunks = 1